const breakpoints = {
  'laptop': 1620,
  'laptopSmall': 1280,
  'tablet': 1200,
  'tabletMiddle': 980,
  'mobile': 767,
  'mobileSmall': 670,
  'mobileMicro': 480
}

const breakpointsMatches = {
  'laptop': window.matchMedia('screen and (max-width: ' + breakpoints.laptop + 'px)'),
  'laptopSmall': window.matchMedia('screen and (max-width: ' + breakpoints.laptopSmall + 'px)'),
  'tablet': window.matchMedia('screen and (max-width: ' + breakpoints.tablet + 'px)'),
  'tabletMiddle': window.matchMedia('screen and (max-width: ' + breakpoints.tabletMiddle + 'px)'),
  'mobile': window.matchMedia('screen and (max-width: ' + breakpoints.mobile + 'px)'),
  'mobileSmall': window.matchMedia('screen and (max-width: ' + breakpoints.mobileSmall + 'px)'),
  'mobileMicro': window.matchMedia('screen and (max-width: ' + breakpoints.mobileMicro + 'px)')
}

export {
  breakpoints,
  breakpointsMatches
}



// WEBPACK FOOTER //
// ./src/shared/breakpoints.js